import { updatePersonOnServer, createPersonAndRelationships } from '../services/services'

const applyValuesForServer = ({ person }) => {
  person = Object.assign(person, {
    gender: person.genderType,
  })

  // Clear death information if they are living.
  if (person.living) {
    person.dod = null
    person.pod = null
    person.podId = null
  }
}

const applyValuesFromServer = (person, personId, t) => {
  person = Object.assign(person, {
    personId,
    lifespan: person.living
      ? `${person.dob}-${t('atf.AncestorEditor.living', 'Living')}`
      : `${person.dob}-${person.dod}`,
  })
}

export default async function sendPersonToServer({ payloadDetails }) {
  if (!payloadDetails || !payloadDetails.person) {
    throw Error('Unable to create person. There are missing details.')
  }

  const { person, child } = payloadDetails
  applyValuesForServer({ person })

  let personId = person.personId

  if (personId) {
    await updatePersonOnServer({ person })
  } else if (child?.personId) {
    personId = await createPersonAndRelationships({ payloadDetails })
  }

  applyValuesFromServer(person, personId, payloadDetails.t)

  return person
}
